<material-navbar
  menuPosition="dashboard-navbar"
  [showToggleButton]="true"
  (toggleButtonClick)="sidenav.toggleSidebarMode()"
>
  <workspace-selector></workspace-selector>
</material-navbar>

<sidenav>
  <nav>
    <custom-menu
      position="dashboard-sidebar"
      [vertical]="true"
      [compact]="sidenav.isCompact$ | async"
      class="vertical"
    ></custom-menu>
    <upgrade-panel [compact]="sidenav.isCompact$ | async"></upgrade-panel>
  </nav>

  <main>
    <ad-host slot="ads.dashboard.top"></ad-host>
    <div class="dashboard-page">
      <router-outlet (activate)="onPageChange($event)" ></router-outlet>
    </div>
    <app-footer *ngIf="settings.get('links.dash_footer')"></app-footer>
  </main>
</sidenav>
